import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_openBlock(), _createBlock(_component_ion_row, {
    size: "12",
    class: "rewards-container d-flex ion-justify-content-center",
    "data-cy": "rewards-container"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_col, {
        size: "12",
        class: "ion-text-center py-0",
        "data-cy": "rewards-message"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_text, { style: {"font-size":"1.2em","color":"black","font-weight":"500"} }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Points, Perks, and Free Pizza.")
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_col, {
        size: "12",
        class: "d-flex ion-justify-content-center mb-8"
      }, {
        default: _withCtx(() => [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = () => _ctx.router.push('/signup')),
            "data-cy": "button-join-now",
            color: "primary",
            class: "pr-8 interstate-bold"
          }, "JOIN DONATOS REWARDS"),
          _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = () => _ctx.router.push('/login')),
            "data-cy": "button-sign-in",
            color: "primary",
            class: "pl-8 interstate-bold"
          }, "LOG IN")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}